/* Herb Garden hair & scalp quiz, in the Fable & Mane quiz flow: one question per screen, a short "loading",
   then a ritual picked from the section's product slots: Oil, Wash, Condition or Treat, a Finish when it suits
   (frizz, shine, heat styling) and Protect. Product text shown in the result comes from the store itself
   (name, "Use:" line, short intro). No dependencies. */
(function () {
  'use strict';
  var root = document.querySelector('[data-fm-quiz]');
  if (!root) return;

  var data = {};
  try { data = JSON.parse(root.querySelector('[data-quiz-data]').textContent) || {}; } catch (e) { data = {}; }

  var ORDER = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'];
  var STORE = 'thg-hair-quiz';
  var A = fresh();
  var cur = 'intro';
  var lastPicks = [];

  var intro = root.querySelector('[data-screen="intro"]');
  var stage = root.querySelector('[data-quiz-stage]');
  var result = root.querySelector('[data-screen="result"]');
  var pool = root.querySelector('[data-quiz-pool]');
  var bar = root.querySelector('[data-quiz-bar]');
  var count = root.querySelector('[data-quiz-count]');

  /* How each answer moves each product slot. Slots are filled in the theme editor (THG quiz section).
     goal, type, oiling and sleep add points for the one answer given; has and routine add points for each one ticked;
     many adds points when three or more concerns are ticked.
     x adds points when every part of a rule matches, e.g. [{ goal: 'fall', has: 'dry_scalp' }, 2].
     skip leaves a slot out when any of its rules match, e.g. no heavy oil or creamy wash for an oily scalp.
     after adds points when the ritual already holds that slot, so matching pairs (Seaweed wash and conditioner) stick.
     The goal leads every step; hair type, scalp, routine and oiling habit decide between the close options. */
  var W = {
    /* step 1: oil */
    oil_fall:    { goal: { fall: 7.5, fuller: 5 }, has: { fall: 2, thin: 1 }, oiling: { weekly: 0.5, sometimes: 0.5 } },
    oil_garlic:  { goal: { scalp: 6.5, fall: 5.5 }, has: { fall: 1.5, oily_scalp: 1.5 }, oiling: { weekly: 2.5, 'new': -1 } },
    oil_scalp:   { goal: { scalp: 6, fall: 5, fuller: 5 }, has: { dry_scalp: 3, thin: 2, fall: 1 }, oiling: { weekly: 1 } },
    oil_fuller:  { goal: { fuller: 7, breakage: 5.5 }, has: { thin: 2, fragile: 1 }, type: { straight: -1, curly: 1, coily: 2 }, oiling: { weekly: 1 }, skip: [{ has: 'oily_scalp' }, { oiling: 'new' }] },
    oil_mustard: { goal: { hydrate: 4.5, scalp: 4.5, fall: 4 }, has: { dry_scalp: 3, dry: 1.5, fall: 0.5 }, type: { straight: -1, curly: 1, coily: 2 }, oiling: { weekly: 3 }, skip: [{ has: 'oily_scalp' }, { oiling: 'new' }] },
    oil_dry:     { goal: { hydrate: 7, frizz: 6, repair: 5 }, has: { dry: 2.5, frizzy: 1.5, dry_scalp: 1.5 }, type: { straight: -0.5, curly: 1.5, coily: 2 }, routine: { colour: 1.5, keratin: 0.5 }, skip: [{ has: 'oily_scalp' }] },
    oil_shine:   { goal: { frizz: 6, shine: 6, hydrate: 4.5 }, has: { dull: 2, frizzy: 1.5, dry: 1, balanced: 1 }, type: { straight: 1, wavy: 1.5 }, routine: { heat: 0.5, keratin: 0.5 }, oiling: { sometimes: 0.5, 'new': 1 } },
    oil_light:   { goal: { shine: 5.5, scalp: 4.5, frizz: 4, hydrate: 3.5 }, has: { oily_scalp: 3.5, dull: 1, frizzy: 0.5 }, type: { straight: 2, wavy: 1, coily: -1 }, oiling: { 'new': 2 } },
    oil_repair:  { goal: { repair: 6, breakage: 5, shine: 4 }, has: { fragile: 3, dull: 1 }, routine: { colour: 1, keratin: 1, heat: 1.5 } },
    oil_house:   { goal: { repair: 5.5, breakage: 5.5, fall: 3, fuller: 3 }, has: { balanced: 4.5, oily_scalp: -0.5 }, many: 2.5, oiling: { sometimes: 1, 'new': 1.5 } },

    /* step 2: wash */
    wash_balance: { goal: { scalp: 7, fall: 6, fuller: 3.5, shine: 2 }, has: { oily_scalp: 4.5, dry_scalp: -2, fall: 0.5 }, type: { straight: 0.5, wavy: 0.5, curly: -0.5, coily: -1 } },
    wash_shine:   { goal: { shine: 7, fuller: 6.5, fall: 4, breakage: 3, repair: 1 }, has: { dull: 2, thin: 2, balanced: 3, oily_scalp: 0.5, dry: -0.5 }, type: { straight: 1.5, wavy: 1, curly: -0.5, coily: -1 }, routine: { heat: 0.5 } },
    wash_dry:     { goal: { hydrate: 6.5, frizz: 6.5, repair: 3.5, scalp: 2, shine: 2, fall: 1 }, has: { dry: 2, frizzy: 2, dry_scalp: 4 }, type: { straight: 1.5, wavy: 1.5, curly: -0.5, coily: -1 }, routine: { colour: 1.5 }, skip: [{ has: 'oily_scalp' }] },
    wash_curl:    { goal: { hydrate: 5.5, frizz: 5, breakage: 4.5, repair: 3.5, fuller: 3.5, shine: 1.5, fall: 1 }, has: { dry: 2, frizzy: 1, fragile: 1, thin: 0.5 }, type: { straight: -1.5, wavy: 0.5, curly: 3.5, coily: 4 }, skip: [{ has: 'oily_scalp' }] },
    wash_strong:  { goal: { repair: 4.5, breakage: 4.5, shine: 2 }, has: { fragile: 2.5 }, routine: { colour: 1, keratin: 3, heat: 1.5 } },

    /* step 3: condition or treat */
    cond_light:  { goal: { fuller: 6.5, scalp: 6.5, fall: 6, shine: 5 }, has: { oily_scalp: 3, thin: 1.5, balanced: 1.5, dry: -1, dry_scalp: -0.5 }, type: { straight: 1.5, wavy: 1, curly: -1, coily: -2 }, after: { wash_balance: 1.5, wash_shine: 0.5 } },
    cond_dry:    { goal: { frizz: 6.5, breakage: 6, hydrate: 4.5, shine: 4, fall: 3.5, scalp: 3, fuller: 2 }, has: { frizzy: 1.5, fragile: 1, dry: 1.5, dry_scalp: 1 }, type: { wavy: 0.5, curly: 2, coily: 1.5 }, routine: { air: 1, tied: 0.5 }, after: { wash_curl: 1.5, wash_dry: 1 } },
    mask_dry:    { goal: { hydrate: 8, repair: 5, frizz: 5, breakage: 3 }, has: { dry: 2.5, frizzy: 0.5, oily_scalp: -2 }, type: { straight: -1.5, wavy: -0.5, curly: 1.5, coily: 2.5 }, routine: { air: 0.5, colour: 1 }, x: [[{ goal: 'frizz', has: 'dry' }, 2.5], [{ goal: 'breakage', has: 'dry' }, 3]], after: { wash_curl: 0.5, wash_dry: 0.5 } },
    mask_repair: { goal: { repair: 7, breakage: 4.5, fall: 3, scalp: 1 }, has: { fragile: 2.5 }, routine: { colour: 2, keratin: 2, heat: 1.5 }, after: { wash_strong: 1, wash_balance: 0.5 } },

    /* step 4: finish, only when it suits (see min in STEPS) */
    finish_serum: { goal: { frizz: 6, shine: 6 }, has: { frizzy: 2, dull: 2 }, routine: { heat: 2, keratin: 0.5, air: 1 }, type: { wavy: 0.5, curly: 0.5 } },

    /* step 5: protect */
    protect_pillow:    { base: 1, sleep: { cotton: 6 }, type: { straight: 0.5, wavy: 0.5 } },
    protect_bonnet:    { sleep: { tied: 5 }, type: { curly: 2, coily: 3 }, x: [[{ sleep: 'cotton', type: 'coily' }, 4.5]] },
    protect_cap:       { sleep: { tied: 5 }, type: { straight: 2, wavy: 1.5 } },
    protect_scrunchie: { sleep: { silk: 6 } },
    protect_box:       { x: [[{ sleep: 'silk', routine: 'tied' }, 7], [{ sleep: 'tied', routine: 'tied' }, 7.5]] }
  };
  var STEPS = [
    { label: 'Oil', roles: ['oil_fall', 'oil_garlic', 'oil_scalp', 'oil_fuller', 'oil_mustard', 'oil_dry', 'oil_shine', 'oil_light', 'oil_repair', 'oil_house'] },
    { label: 'Wash', roles: ['wash_balance', 'wash_shine', 'wash_dry', 'wash_curl', 'wash_strong'] },
    { label: '', roles: ['cond_light', 'cond_dry', 'mask_dry', 'mask_repair'] },
    { label: 'Finish', roles: ['finish_serum'], min: 5 },
    { label: 'Protect', roles: ['protect_pillow', 'protect_bonnet', 'protect_cap', 'protect_scrunchie', 'protect_box'] }
  ];

  function is(key, val) { var a = A[key]; return Array.isArray(a) ? a.indexOf(val) > -1 : a === val; }
  function fits(rule) { for (var k in rule) { if (!is(k, rule[k])) return false; } return true; }

  function score(role, picked) {
    var w = W[role] || {}, s = w.base || 0;
    s += v(w.goal, A.goal) + v(w.type, A.type) + v(w.oiling, A.oiling) + v(w.sleep, A.sleep);
    A.has.forEach(function (h) { s += v(w.has, h); });
    A.routine.forEach(function (r) { s += v(w.routine, r); });
    if (A.has.length > 2) s += w.many || 0;
    (w.x || []).forEach(function (rule) { if (fits(rule[0])) s += rule[1]; });
    (picked || []).forEach(function (r) { s += v(w.after, r); });
    return s;
  }

  /* the best slot for a step that is in stock; a step with a min only joins the ritual when it clearly suits */
  function choose(step, picked) {
    var best = null, top = -1e9;
    step.roles.forEach(function (r, i) {
      var p = data[r];
      if (!p || !p.avail || (W[r] && (W[r].skip || []).some(fits))) return;
      var s = score(r, picked) - i * 0.01;
      if (s > top) { top = s; best = r; }
    });
    return best && (step.min == null || top >= step.min) ? best : null;
  }

  function ritual() {
    var picks = [], roles = [];
    STEPS.forEach(function (st) {
      var r = choose(st, roles);
      if (r) { roles.push(r); picks.push({ step: st, role: r, p: data[r] }); }
    });
    return picks;
  }

  var HEAD = {
    fall: 'Your hair fall ritual!', fuller: 'Your ritual for fuller-looking hair!', hydrate: 'Your hydration ritual!',
    repair: 'Your repair ritual!', frizz: 'Your ritual for less frizz!', shine: 'Your shine ritual!',
    breakage: 'Your ritual for less breakage!', scalp: 'Your calm-scalp ritual!'
  };
  var NUM = ['', 'One step', 'Two steps', 'Three steps', 'Four steps', 'Five steps'];
  var PROTECT_USE = {
    protect_pillow: 'Sleep on it every night.',
    protect_bonnet: 'Wear it to bed, over loose or tied hair.',
    protect_cap: 'Wear it to bed so your hair stays put till morning.',
    protect_scrunchie: 'Swap your everyday hair ties for silk.',
    protect_box: 'Swap every hair tie for silk, day and night.'
  };

  function fresh() { return { type: null, has: [], routine: [], oiling: null, goal: null, sleep: null }; }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function money(c) { return 'Rs.' + Math.round(c / 100).toLocaleString('en-PK'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function v(map, key) { return map && key && map[key] ? map[key] : 0; }
  function label(g, val) { var b = root.querySelector('[data-q="' + g + '"][data-v="' + val + '"]'); return b ? (b.getAttribute('data-label') || b.textContent).trim() : ''; }

  function toTop() {
    var h = document.querySelector('.thg-header-section');
    var y = root.getBoundingClientRect().top + window.pageYOffset - (h ? h.getBoundingClientRect().height : 0);
    if (window.pageYOffset > y + 2) window.scrollTo(0, Math.max(0, y));
  }

  function show(name) {
    cur = name;
    intro.hidden = name !== 'intro';
    result.hidden = name !== 'result';
    stage.hidden = !(ORDER.indexOf(name) > -1 || name === 'loading');
    $$('[data-screen]', stage).forEach(function (s) { s.hidden = s.getAttribute('data-screen') !== name; });
    var i = ORDER.indexOf(name);
    if (bar) bar.style.width = (i < 0 ? 100 : Math.round(((i + 1) / ORDER.length) * 100)) + '%';
    if (count) count.textContent = i < 0 ? '' : 'Question ' + (i + 1) + ' of ' + ORDER.length;
    toTop();
    var screen = root.querySelector('[data-screen="' + name + '"]');
    var h = screen && screen.querySelector('[tabindex="-1"]');
    if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
  }

  function paint(group, list) {
    $$('[data-q]', group).forEach(function (x) { x.setAttribute('aria-pressed', String(list.indexOf(x.getAttribute('data-v')) > -1)); });
    var screen = group.closest('[data-screen]');
    var nb = screen && screen.querySelector('[data-quiz-next]');
    if (nb) nb.disabled = !list.length;
  }

  function pick(b) {
    var q = b.getAttribute('data-q'), val = b.getAttribute('data-v');
    var group = b.closest('[data-group]');
    if (!group.hasAttribute('data-multi')) {
      A[q] = val;
      paint(group, [val]);
      setTimeout(next, 260);
      return;
    }
    var list = A[q].slice();
    var max = parseInt(group.getAttribute('data-max') || '99', 10);
    var at = list.indexOf(val);
    if (at > -1) {
      list.splice(at, 1);
    } else {
      var only = $$('[data-only]', group).map(function (x) { return x.getAttribute('data-v'); });
      if (b.hasAttribute('data-only')) list = [];
      else list = list.filter(function (x) { return only.indexOf(x) < 0; });
      if (list.length >= max) {
        var hint = group.parentNode.querySelector('[data-quiz-hint]');
        if (hint) { hint.classList.remove('is-shake'); void hint.offsetWidth; hint.classList.add('is-shake'); }
        return;
      }
      list.push(val);
    }
    A[q] = list;
    paint(group, list);
  }

  function next() {
    var i = ORDER.indexOf(cur);
    if (i < 0) return;
    if (i < ORDER.length - 1) { show(ORDER[i + 1]); return; }
    show('loading');
    /* fetch the ritual's pictures while "Your ritual is loading" is on screen */
    ritual().forEach(function (x) { if (x.p.img) { var im = new Image(); im.src = x.p.img; } });
    setTimeout(function () { finish(false); }, 1700);
  }

  function stepLabel(step, role) {
    if (step.label) return step.label;
    if (role.indexOf('mask_') === 0) return 'Treat';
    if (role.indexOf('finish_') === 0) return 'Finish';
    return 'Condition';
  }

  function cardsHome() {
    $$('[data-role]', result).forEach(function (c) { pool.appendChild(c); });
  }

  function render(picks) {
    lastPicks = picks;
    var heading = root.querySelector('[data-r-heading]');
    heading.textContent = HEAD[A.goal] || 'Your hair ritual!';
    var type = label('type', A.type).toLowerCase();
    root.querySelector('[data-r-sub]').textContent = (NUM[picks.length] || picks.length + ' steps') + (type ? ' for your ' + type + ' hair.' : ' for your hair.');

    /* the ritual at a glance: one round picture per step (cut-out pack shots sit inside the circle, studio shots fill it) */
    var pics = picks.filter(function (x) { return x.p.img; });
    var lineup = root.querySelector('[data-r-lineup]');
    lineup.innerHTML = pics.length > 1 ? pics.map(function (x) {
      return '<span class="fm-quiz__bub' + (x.p.cut ? ' fm-quiz__bub--cut' : '') + '"><img src="' + esc(x.p.img) + '" alt="' + esc(x.p.title) + '" width="300" height="300"></span>';
    }).join('') : '';
    lineup.hidden = pics.length < 2;
    lineup.setAttribute('data-n', pics.length);

    var sum = 0, was = 0;
    picks.forEach(function (x) { sum += x.p.price; was += Math.max(x.p.compare || 0, x.p.price); });
    root.querySelector('[data-r-total]').innerHTML = (was > sum ? '<s>' + money(was) + '</s> ' : '') + '<b>' + money(sum) + '</b>';

    var addable = picks.filter(function (x) { return !x.p.pick; });
    var shop = root.querySelector('[data-r-shop]');
    shop.hidden = !addable.length;
    var needPick = picks.filter(function (x) { return x.p.pick; });
    var note = root.querySelector('[data-r-note]');
    note.textContent = needPick.length ? 'Pick your colour for the ' + needPick.map(function (x) { return x.p.title; }).join(' and the ') + ' below.' : '';
    note.hidden = !needPick.length;
    var msg = root.querySelector('[data-r-msg]'); if (msg) { msg.hidden = true; msg.textContent = ''; }

    root.querySelector('[data-r-steps]').innerHTML = picks.map(function (x, i) {
      var use = x.role.indexOf('protect_') === 0 ? (PROTECT_USE[x.role] || x.p.use) : x.p.use;
      return '<li class="fm-quiz__step"><p class="fm-quiz__stepn">Step ' + (i + 1) + ' &middot; ' + esc(stepLabel(x.step, x.role)) + '</p>' +
        '<a class="fm-d fm-quiz__stept" href="' + esc(x.p.url) + '">' + esc(x.p.title) + '</a>' +
        (x.p.line ? '<p class="fm-quiz__stepl">' + esc(x.p.line) + '</p>' : '') +
        (use ? '<p class="fm-quiz__stepu">' + esc(use) + '</p>' : '') + '</li>';
    }).join('');

    cardsHome();
    var cards = root.querySelector('[data-r-cards]');
    picks.forEach(function (x) { var c = pool.querySelector('[data-role="' + x.role + '"]'); if (c) cards.appendChild(c); });
    cards.setAttribute('data-n', cards.children.length);

    var tips = [];
    if (A.oiling === 'new') tips.push('New to oiling? Start once a week: massage a little into your scalp, leave it for an hour, then wash it out.');
    if (A.goal === 'fall' || A.has.indexOf('fall') > -1 || A.has.indexOf('thin') > -1) tips.push('Sudden or heavy hair fall? Please check with a doctor as well.');
    if (A.sleep === 'silk') tips.push('Already sleeping on silk? Lovely. Silk scrunchies keep the day gentle too.');
    var t = root.querySelector('[data-r-tips]');
    t.innerHTML = tips.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('');
    t.hidden = !tips.length;
  }

  function finish(fromSaved) {
    var picks = ritual();
    render(picks);
    if (!fromSaved) save();
    show('result');
  }

  function shopAll(btn) {
    var items = lastPicks.filter(function (x) { return !x.p.pick; }).map(function (x) { return { id: x.p.vid, quantity: 1 }; });
    if (!items.length || !window.fetch) return;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        var t = document.querySelector('[data-thg-open-cart]');
        if (t) t.click(); else window.location.href = '/cart';
      })
      .catch(function () {
        var msg = root.querySelector('[data-r-msg]');
        if (msg) { msg.textContent = 'Sorry, that didn’t work. Please add each product from the cards below.'; msg.hidden = false; }
      })
      .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  }

  function save() { try { window.localStorage.setItem(STORE, JSON.stringify(A)); } catch (e) { /* private mode */ } }
  function load() {
    try {
      var s = JSON.parse(window.localStorage.getItem(STORE) || 'null');
      if (!s || !s.goal || !s.type || !s.sleep) return false;
      A = { type: s.type, has: s.has || [], routine: s.routine || [], oiling: s.oiling || null, goal: s.goal, sleep: s.sleep };
      return true;
    } catch (e) { return false; }
  }

  function reset() {
    A = fresh();
    $$('[data-q]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
    $$('[data-quiz-next]').forEach(function (x) { x.disabled = true; });
    cardsHome();
  }

  root.addEventListener('click', function (e) {
    var b;
    if ((b = e.target.closest('[data-quiz-start]'))) { reset(); show('q1'); return; }
    if ((b = e.target.closest('[data-quiz-last]'))) { if (load()) finish(true); return; }
    if ((b = e.target.closest('[data-quiz-back]'))) { var i = ORDER.indexOf(cur); show(i > 0 ? ORDER[i - 1] : 'intro'); return; }
    if ((b = e.target.closest('[data-quiz-retake]'))) { reset(); show('q1'); return; }
    if ((b = e.target.closest('[data-quiz-next]'))) { if (!b.disabled) next(); return; }
    if ((b = e.target.closest('[data-r-shop]'))) { shopAll(b); return; }
    if ((b = e.target.closest('[data-q]'))) pick(b);
  });

  /* someone who already took it gets a shortcut back to their ritual */
  try {
    var saved = JSON.parse(window.localStorage.getItem(STORE) || 'null');
    var last = root.querySelector('[data-quiz-last]');
    if (saved && saved.goal && last) last.hidden = false;
  } catch (e) { /* ignore */ }
  root.classList.add('is-ready');
})();
